import { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';

export default class PopupMessage extends Component{
    render(){
        return(
            <>
                <div className='seccess-popup'>
                    <div className='content-wraper'>
                      <i className='popup_close' onClick={ () => this.props.closePopup && this.props.closePopup() }><Close/></i>
                      <p>
                        {this.props.message}
                      </p>
                      <div className='action'>
                        <Link to={ window.location.pathname } onClick={ () => this.props.closePopup && this.props.closePopup() } className='btn btn_primary'>ok</Link>
                      </div>
                    </div>
                  </div>
            </>
        )
    }
}